export default {
  namespaced: true,
  state: {
    dataList: [
      // {
      //   name: "化工原料生产设备运维管理",
      //   img: "img/exhibition-hall/success-cases/1_0.png",
      //   text: "陕西延长石油氟硅化工有限公司基于“一物一码”标识采集工业设备使用过程数据，实现了设备的全流程信息管理和无纸化巡检。",
      //   html: `<div>
      //     <p>陕西延长石油氟硅化工有限公司基于“一物一码”标识采集工业设备使用过程数据，实现了设备的全流程信息管理和无纸化巡检。
      //     通过扫描设备二维码，管理人员既可查看设备基础信息、电子档案，也能对设备在使用过程中的安装、巡检、保养、报修、维修等环节进行便捷操作及数据采集，确保数据的准确性、及时性、完整性，实现运维管理过程的信息追溯，进而节省保修时间。</p>
      //     <img src="img/exhibition-hall/success-cases/1_1.png" style="margin: 0 auto;">
      //     <p>该系统基于工业互联网标识解析体系为设备赋予唯一的二维码，记录设备全生命周期运维数据，并对保养、运行、维修情况等进行统计分析，提供指标监控应用、自动化报表分析、定位分布统计，进行风险评估预测，提升设备综合效能，实现价值最大化。</p>
      //   </div>`,
      //   tags: "新能源汽车,装备制造,生物医药,现代食品,新材料(绿色建材),信息创新(数字经济),现代物流",
      //   time: "2021-05-11",
      // },
      // {
      //   name: "危化品容器吨桶管理",
      //   img: "img/exhibition-hall/success-cases/2_0.png",
      //   text: "陕西延长石油氟硅化工有限公司主要生产35%氢氟酸，其专用容器吨桶涉及报废期限管理，清洗、重复利用，回收登记，专桶专用等需求，以往管理采用纸质登记，存在管理混乱、查询难度大等问题。基于以上情况，经达为专用容器赋予唯一标识二维码，在过程中进行数据采集和关联，便于溯源查询，可对报废时间进行预警提示，从而实现节约人力、降低成本、提高效率等效果。",
      //   html: `<div>
      //     <p>陕西延长石油氟硅化工有限公司主要生产35%氢氟酸，其专用容器吨桶涉及报废期限管理，清洗、重复利用，回收登记，专桶专用等需求，以往管理采用纸质登记，存在管理混乱、查询难度大等问题。基于以上情况，经达为专用容器赋予唯一标识二维码，在过程中进行数据采集和关联，便于溯源查询，可对报废时间进行预警提示，从而实现节约人力、降低成本、提高效率等效果。</p>
      //     <img src="img/exhibition-hall/success-cases/2_1.png" style="margin: 0 auto;">
      //     <h3>该案例的实施成效包括：</h3><div>1、实现吨桶终身“一码制”；<br />
      //     2、建立进出登记管理制度，减少人力成本约60%；<br />
      //     3、吨桶实际使用寿命由12个月提升至18个月；<br />
      //     4、为企业减少了定期吨桶采购的成本；<br />
      //     5、减少了在填充产品过程中的资源浪费。</div>
      //   </div>`,
      //   tags: "新能源汽车,装备制造,生物医药,现代食品,新材料(绿色建材),信息创新(数字经济),现代物流",
      //   time: "2021-10-01",
      // },
      // {
      //   name: "钻井施工成本溯源管理系统",
      //   img: "img/exhibition-hall/success-cases/3_0.png",
      //   text: "钻井施工成本溯源管理系统是基于工业互联网标识体系为每一口井赋予具有唯一性的身份标识二维码。将当前井所发生的成本相关事件记录到当前井的标识二维码下。该系统能够实时监控和管理钻井施工过程中的各项成本事件，及时发现和解决成本异常情况，为公司财务人员、管理人员判断事件信息的真实性提供有效支撑，有效提高了成本控制的效率和精度，实现对成本的全面掌控和管理。此外，该系统还提供了对井队人员的相关证件到期预警、设备检验到期预警等功能。为井队管理人员提供了有力的数据支持，提高了钻井施工的效率和质量,节约了各方面的人力及时间成本，为控制钻井施工成本打下了良好的基础,避免了成本超支的情况。",
      //   html: `<div>
      //     <p>钻井施工成本溯源管理系统是基于工业互联网标识体系为每一口井赋予具有唯一性的身份标识二维码。将当前井所发生的成本相关事件记录到当前井的标识二维码下。该系统能够实时监控和管理钻井施工过程中的各项成本事件，及时发现和解决成本异常情况，为公司财务人员、管理人员判断事件信息的真实性提供有效支撑，有效提高了成本控制的效率和精度，实现对成本的全面掌控和管理。此外，该系统还提供了对井队人员的相关证件到期预警、设备检验到期预警等功能。为井队管理人员提供了有力的数据支持，提高了钻井施工的效率和质量,节约了各方面的人力及时间成本，为控制钻井施工成本打下了良好的基础,避免了成本超支的情况。</p>
      //     <img src="img/exhibition-hall/success-cases/3_1.png" style="margin: 0 auto;">
      //     <h3>陕西经纬石油科技工程有限公司引入该系统后实现了以下成效：</h3>
      //     <p style="white-space: pre-line">1、解决了施工现场费用“事件”发生的真实性、及时性问题，提升了业务透明度展示了现场事件发生的真实情况，为项目成本核算提供了有力的佐证记录。
      //     2、对钻井工程实施过程中的相关费用事件可快速追溯查询。
      //     3、采用谁发生谁记录的方式、无需专人值守登记，井队无需新增人员实现人员“零”投入。
      //     4、管理人员可随时查看相关数据记录报表（单井核算表、服务商费用表、年度汇总表等），无需专人进行数据统计，打开系统即可随时查看。以前需要专人进行统计整理，需要2-3天时间才可完成，现在随时打开系统可实时查看相关数据报表。帮助管理人员及时了解的成本情况，以便及时做出相对应的决策。
      //     5、提供事件管理标准模板、将现场的操作过程进行模板化设置，现场人员只需点选操作、简单文字记录、拍照即可完成，实现数据及时录入、共享，减少重复劳动。
      //     6、系统的人员证件到期预警提醒和设备到期检验预警提醒服务为管理人员在证件和设备的到期问题上提供了极大的帮助，减少了工作处理的时间和工作量，同时也提高了工作效率，从以前的人工处理表格核对相关人员证件日期和设备检验日期需要最少半天时间，现在只需打开系统直接就能看到，导出相关数据即可。以前需要3-5小时的工作现在仅需3-5分钟即可完成。</p>
      //   </div>`,
      //   tags: "新能源汽车,装备制造,生物医药,现代食品,新材料(绿色建材),信息创新(数字经济),现代物流",
      //   time: "2021-10-01",
      // },
      // {
      //   name: "设备装配管理系统",
      //   img: "img/exhibition-hall/success-cases/4_0.png",
      //   text: "钻井施工成本溯源管理系统是基于工业互联网标识体系为每一口井赋予具有唯一性的身份标识二维码。将当前井所发生的成本相关事件记录到当前井的标识二维码下。该系统能够实时监控和管理钻井施工过程中的各项成本事件，及时发现和解决成本异常情况，为公司财务人员、管理人员判断事件信息的真实性提供有效支撑，有效提高了成本控制的效率和精度，实现对成本的全面掌控和管理。此外，该系统还提供了对井队人员的相关证件到期预警、设备检验到期预警等功能。为井队管理人员提供了有力的数据支持，提高了钻井施工的效率和质量,节约了各方面的人力及时间成本，为控制钻井施工成本打下了良好的基础,避免了成本超支的情况。",
      //   html: `<p style="text-indent: 2em;"><span style="font-family: 宋体;">工业互联网标识码的深度应用，在设备设施管理中较好的解决了数字化档案、销售分布、防伪溯源、动态跟踪、健康状况、安全预警、主动服务等问题。打破了传统的组织架构管理模式的束缚，创新了以“物”为中心的灵活、便捷的新模式</span>。</p><p><img src="img/exhibition-hall/solution/5_4_1.png" alt="" data-href="" style=""/> </p><p><span style="font-family: 宋体;">装配设备一般是由多个独立的设备（部件）组装而成，将装配后形成的设备和独立的设备（部件）分别赋予标识二维码，并进行主从关联，有效解决设备及部件的溯源问题</span></p>`,
      //   tags: "新能源汽车,装备制造,生物医药,现代食品,新材料(绿色建材),信息创新(数字经济),现代物流",
      //   time: "2021-10-01",
      // }
    ]
  }
}
